<div class="card-header bg-primary">
  <div class="row">
    <div class="col-12 d-flex justify-content-center flex-column">
      <h3 class="m-0">{{ "automatic-value.title" | translate }}</h3>
      <small>{{ "automatic-value.subtitle" | translate }}</small>
    </div>
  </div>
</div>

<div class="card-body">
  <div class="row" *ngIf="interval === '3_days' || interval ===  '5_days'">
    <div class="col-12">
      {{ "automatic-value.select-hours-of-day" | translate }}:
      <select class="form-control" name="" id="" (change)="changeSelectHours($event.target.value)">
        <option value="">{{ "automatic-request.select-hour-of-day" | translate }}</option>
        <option *ngFor="let item of filterSelectItem(hours);" [value]="item">{{item}}</option>
      </select>
    </div>
    <div class="col-12">
      <div class="d-flex align-items-center" *ngIf="hoursSelected && hoursSelected.length > 0">
        <span
          class="m-0 mr-2 font-weight-bold item-delete mt-2"
          *ngFor="let item of hoursSelected;let i = index;"
          (click)="deleteHour(i)"
          >{{item}} <em class="fa fa-times text-danger"></em
        ></span>
      </div>
    </div>
  </div>
  <div class="row align-items-center my-3">
    <div class="col-4">
      <div class="form-check mr-2">
        <input
          class="form-check-input"
          type="radio"
          name="interval"
          value="c_hours"
          id="c_hours"
          [(ngModel)]="interval"
          [checked]="interval === 'c_hours'"
        />
        <label class="form-check-label" for="c_hours"> {{ "automatic-request.every-hour" | translate }} </label>
      </div>
    </div>
    <div class="col-4">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="interval"
          value="3_days"
          id="3_days"
          [(ngModel)]="interval"
          [checked]="interval === '3_days'"
          (change)="validatechangedays()"
        />
        <label class="form-check-label" for="3_days"> {{ "automatic-request.3-times-a-day" | translate }} </label>
      </div>
    </div>
    <div class="col-4">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="interval"
          value="5_days"
          id="5_days"
          [(ngModel)]="interval"
          [checked]="interval === '5_days'"
        />
        <label class="form-check-label" for="5_days"> {{ "automatic-request.5-times-a-day" | translate }} </label>
      </div>
    </div>
  </div>
  <ng-container *ngIf="interval === '3_days' || interval === '5_days' || interval === 'c_hours'">
    <div class="d-flex justify-content-end align-items-center">
      <button class="btn btn-secondary m-2 p-2" (click)="SubmitInput()">
        <img src="assets/img/icons/guardar.png" alt="guardar" width="20" />
      </button>
    </div>
  </ng-container>
</div>
